import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    supplierName: yup.string().required("Supplier Name is required"),
    supplierPhone: yup
      .string()
      .matches(/^[0-9]+$/, "Phone number must contain only digits")
      .test("num", "Invalid phone number format", (val) => !val.startsWith("0"))
      .min(9, "Invalid phone number format")
      .max(11, "Invalid phone number format"),
    supplierContactName: yup
      .string()
      .required("Supplier contact name is required"),
    supplierAddress: yup.string().required("Address is required"),
    openingBalance: yup.string(),
  })
  .required("All fields are required");

const Validation = ({ supplierDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      supplierName: supplierDetails?.name,
      supplierPhone: supplierDetails?.phone_number,
      supplierContactName: supplierDetails?.contact_name,
      supplierAddress: supplierDetails?.address,
      openingBalance: supplierDetails?.opening_balance,
    },
  });
};

export default Validation;
